<app-admin-navbar></app-admin-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>